<se-fe-card [seFeDataFullHeight]="true">
  <se-fe-card-header seFeDataTitle="{{ cardName }}" seFeDataHeavyBorder="true">
    <div seFeCardHeaderActions>
      <item-details-modal
        [product]="product"
        [price]="price ?? 0"
        [error]="error"
        (save)="onUpdateProductAndPriceBreak($event)"
        class="item-detail-edit-modal item-detail-modal"
        id="edit-modal"></item-details-modal>
    </div>
  </se-fe-card-header>
  <se-fe-card-content id="item-detail__item-details">
    <se-fe-grid seFeGridOpts>
      <se-fe-grid-cell seFeGridOpts>
        <se-fe-form-field [seFeDataConfig]="productNameLabel"></se-fe-form-field>
        <p class="product-name">{{ productName || '--' }}</p>
      </se-fe-grid-cell>
      @if (isBundle()) {
        <se-fe-grid-cell seFeGridOpts>
          <se-fe-form-field [seFeDataConfig]="itemNumberLabel"></se-fe-form-field>
          <p class="product-id">{{ itemNumber }}</p>
        </se-fe-grid-cell>
      }
    </se-fe-grid>
    <se-fe-grid seFeGridOpts>
      <se-fe-grid-cell seFeGridOpts="1/2">
        <se-fe-form-field [seFeDataConfig]="productPriceLabel"></se-fe-form-field>
        <p class="product-price">{{ (price | currency) || '--' }}</p>
      </se-fe-grid-cell>
    </se-fe-grid>
    <se-fe-grid seFeGridOpts>
      <se-fe-grid-cell seFeGridOpts>
        <div class="bundledetail">
          <se-fe-form-field [seFeDataConfig]="productDescriptionLabel"></se-fe-form-field>
          <div
            class="product-description quill-display-content ql-editor"
            [innerHtml]="productDescription || '--'"></div>
        </div>
      </se-fe-grid-cell>
    </se-fe-grid>
  </se-fe-card-content>
</se-fe-card>
